/**
 * Props for the Zoom slot component.
 * @public
 */
export interface ZoomSlotProps {
  /**
   * Whether the zoom is disabled.
   */
  disabled?: boolean;
}

/**
 * Zoom slot component.
 * @public
 */
export const Zoom = (props: ZoomSlotProps) => null;

Zoom['displayName'] = 'HistogramChart.Zoom';
